import styled, { css, keyframes } from 'styled-components';
import { CompletedBadge } from '../BlobPathComponent/styles';

const settle = keyframes`
  from { transform: scale(0.8); }
  to { transform: scale(1); }
`;

export const Image = styled.span(
  ({ theme }) => css`
    position: relative;
    display: grid;
    place-items: center;
    width: 100%;
    aspect-ratio: 1;
    border: ${theme.bo.mediumWidth} solid ${theme.co.primary30};
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.primary95};
    color: ${theme.co.neutral10};
    font-size: ${theme.sz.s6};

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: inherit;
    }
  `,
);

export const Check = styled(CompletedBadge)<{ $compact: boolean }>(
  ({ theme, $compact }) => css`
    width: ${$compact ? theme.sz.s4 : theme.sz.s5};
    height: ${$compact ? theme.sz.s4 : theme.sz.s5};
    border-color: ${theme.co.neutral99};
    animation: ${settle} 250ms 150ms ease-out both;

    ${
      $compact &&
      css`
        inset-inline-end: -${theme.sz.s05};
        bottom: -${theme.sz.s05};
      `
    }

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `,
);
